import type { RouteObject } from "react-router";

/**
 * The Face Kiosk workspace's routes (M24, contracts §11), in a file of their own like `studentsRoutes.tsx` —
 * `index.tsx` mounts this under the shell in one line.
 *
 * One layout route for the whole workspace: `FaceKioskWorkspaceGate` answers "is Access Control live" and "is
 * Face Kiosk switched on" once (the entitlements and the settings, or any Face Kiosk read refused `402
 * ADDON_REQUIRED` / `409 FACE_KIOSK_OFF`) and shows its panel in the page's place. Every page is a file in C1's
 * folders (`src/modules/faceKiosk/<area>/pages/`); C1 replaces the file and never edits this table. A seat's
 * detail is a drawer on Seats (`?seat=`), not a route.
 */
export const faceKioskRoute: RouteObject = {
  path: "face-kiosk",
  lazy: async () => ({
    Component: (await import("@/modules/faceKiosk/shared/FaceKioskWorkspaceGate")).FaceKioskWorkspaceGate,
  }),
  children: [
    {
      index: true,
      handle: { title: "Seats" },
      lazy: async () => ({
        Component: (await import("@/modules/faceKiosk/seats/pages/FaceKioskSeatsPage")).FaceKioskSeatsPage,
      }),
    },
    {
      path: "scans",
      handle: { title: "Scans" },
      lazy: async () => ({
        Component: (await import("@/modules/faceKiosk/scans/pages/FaceKioskScansPage")).FaceKioskScansPage,
      }),
    },
    {
      path: "approvals",
      handle: { title: "Approvals" },
      lazy: async () => ({
        Component: (await import("@/modules/faceKiosk/approvals/pages/FaceKioskApprovalsPage"))
          .FaceKioskApprovalsPage,
      }),
    },
    {
      path: "consent",
      handle: { title: "Consent" },
      lazy: async () => ({
        Component: (await import("@/modules/faceKiosk/consent/pages/FaceKioskConsentPage"))
          .FaceKioskConsentPage,
      }),
    },
    {
      // "Face Kiosk settings", not "Settings": the organisation's own Settings follows the reader into every
      // workspace, and two entries called Settings in one sidebar is one too many (the `staff-settings` rule).
      path: "settings",
      handle: { title: "Face Kiosk settings" },
      lazy: async () => ({
        Component: (await import("@/modules/faceKiosk/settings/pages/FaceKioskSettingsPage"))
          .FaceKioskSettingsPage,
      }),
    },
  ],
};
